import { useContext, useCallback } from "react";
import { Grid2 as Grid, Stack, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import GroupIcon from "@mui/icons-material/Group";
import { AppContext } from "../App";
import { ImageButton } from "../components/ImageButton";
import { usePostHog } from "@posthog/react";

const OPTIONS = [
  { value: "For Myself", label: "For Myself", Icon: PersonIcon },
  { value: "For Someone Else", label: "For Someone Else", Icon: GroupIcon },
] as const;

export function ForWhom() {
  const { form, updateForm } = useContext(AppContext);
  const posthog = usePostHog();

  const handleSubmit = useCallback(
    (value: string) => {
      updateForm({ forWhom: value });
      posthog?.capture("for_whom_selected", { selection: value });
    },
    [updateForm, posthog]
  );

  return (
    <Stack direction="column" spacing={2} alignItems="center">
      <Typography variant="h6">Are you seeking a provider for yourself or on behalf of someone else?</Typography>
      <Grid container columns={{ xs: 1, sm: 2, md: 3 }} justifyContent="center" spacing={2}>
        {OPTIONS.map(({ value, label, Icon }) => (
          <Grid key={value}>
            <ImageButton
              selected={form.forWhom === value}
              label={label}
              image={<Icon />}
              onClick={() => handleSubmit(value)}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
